import axios from 'axios';

import { AI_ONBOARDING_BASE_URL } from 'src/modules/3rd-party-management/constants';

export default class AIOnboardingService {
	static instance;

	static getInstance() {
		if (!AIOnboardingService.instance) {
			AIOnboardingService.instance = new AIOnboardingService();
		}

		return AIOnboardingService.instance;
	}

    async getCurrentStep() {
        const response = await axios.get(`${AI_ONBOARDING_BASE_URL}/onboarding/processing/processing_status`,{
            headers: {
                Authorization: `Bearer ${localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN")}`
            }
        });
        return response.data?.data || []; 
    }

    async getCurrentUploadedFile() {
        const response = await axios.get(`${AI_ONBOARDING_BASE_URL}/onboarding/active`,{
            headers: {
                Authorization: `Bearer ${localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN")}`
            }
        });
        return response.data?.data || []; 
    }

    async startProcess(payload = {}) {
        const response = await axios.post(`${AI_ONBOARDING_BASE_URL}/onboarding/processing/start`, payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );
  
        return response.data?.data;
    }

    async validateCompleteness(payload = {}) {
        const response = await axios.post(`${AI_ONBOARDING_BASE_URL}/onboarding/validate-completeness`, payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );
  
        return response.data?.data;
    }

    async getPrepareStatus() {
        const response = await axios.get(`${AI_ONBOARDING_BASE_URL}/onboarding/prepare/status`,{
            headers: {
                Authorization: `Bearer ${localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN")}`
            }
        });
        return response.data?.data || []; 
    }

    async startProductsProcess(payload = {}) {
        const response = await axios.post(`${AI_ONBOARDING_BASE_URL}/onboarding/finalize-products`, payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );
  
        return response.data?.data;
    }

    async getFinalizeStatus() {
        const response = await axios.get(`${AI_ONBOARDING_BASE_URL}/onboarding/finalize/status`,{
            headers: {
                Authorization: `Bearer ${localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN")}`
            }
        });
        return response.data?.data || []; 
    }

    async getFinalizationProgress() {
        const response = await axios.get(`${AI_ONBOARDING_BASE_URL}/onboarding/finalization-progress`,{
            headers: {
                Authorization: `Bearer ${localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN")}`
            }
        });
        return response.data?.data || []; 
    }

    async getLogs() {
        const response = await axios.get(`${AI_ONBOARDING_BASE_URL}/onboarding/processing/records-log`,{
            headers: {
                Authorization: `Bearer ${localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN")}`
            }
        });
        return response.data?.data || []; 
    }

    async getProductsProcessingingLogs() {
        const response = await axios.get(`${AI_ONBOARDING_BASE_URL}/onboarding/processing/product-records-log`,{
            headers: {
                Authorization: `Bearer ${localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN")}`
            }
        });
        return response.data?.data || []; 
    }

    async finalizeCurrentProcess(payload = {}) {
        const response = await axios.post(`${AI_ONBOARDING_BASE_URL}/onboarding/consent`, payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );
  
        return response.data?.data;
    }

    async cancelCurrentProcess(payload = {}) {
        const response = await axios.post(`${AI_ONBOARDING_BASE_URL}/onboarding/cancel`, payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );
  
        return response.data?.data;
    }
}
